import React, { useEffect, createElement } from 'react';
import { HeroSection } from './sections/HeroSection';
import { ProblemSection } from './sections/ProblemSection';
import { SolutionSection } from './sections/SolutionSection';
import { TomosSection } from './sections/TomosSection';
import { BonusPricingSection } from './sections/BonusPricingSection';
import { TestimonialsFAQSection } from './sections/TestimonialsFAQSection';
import { SocialProofPopup } from './SocialProofPopup';
export function SalesPage() {
  useEffect(() => {
    const pixelId = '1264759795107303';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return <main className="min-h-screen bg-white font-sans text-gray-900 selection:bg-yellow-200 selection:text-gray-900" data-id="element-1">
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonusPricingSection data-id="element-6" />
      <TestimonialsFAQSection data-id="element-7" />
      <SocialProofPopup data-id="element-8" />
    </main>;
}